import { render, staticRenderFns } from "./AddressBookByPublicKey.vue?vue&type=template&id=38bbdaf4&scoped=true&"
import script from "./AddressBookByPublicKey.vue?vue&type=script&lang=js&"
export * from "./AddressBookByPublicKey.vue?vue&type=script&lang=js&"
import style0 from "./AddressBookByPublicKey.vue?vue&type=style&index=0&id=38bbdaf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bbdaf4",
  null
  
)

export default component.exports